import React, { useEffect } from "react";
import styles from "../../assets/styles/Homepage/GoogleReviews.module.css";

const GoogleReviews = ({
  sectionLabel = "",
  heading = "What Students Are Saying",
  description = "",
}) => {
  useEffect(() => {
    if (!document.getElementById("elfsight-script")) {
      const script = document.createElement("script");
      script.id = "elfsight-script";
      script.src = "https://elfsightcdn.com/platform.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className={styles.reviewsSection}>
      <div className={`container ${styles.inner}`}>
        {sectionLabel ? <p className={styles.label}>{sectionLabel}</p> : null}
        {heading ? <h2 className={styles.heading}>{heading}</h2> : null}
        {description ? <p className={styles.description}>{description}</p> : null}

        <div
          className="elfsight-app-e301d003-de7f-4605-bd00-ea003df42f14"
          data-elfsight-app-lazy
        ></div>
      </div>
    </section>
  );
};

export default GoogleReviews;
